import { useEffect } from "react";
function useFormInitiallyScrollToField(form, field) {
    useEffect(()=>{
        setTimeout(()=>{
            form.scrollToField(field, {
                behavior: "smooth",
                block: "center"
            });
        }, 0);
    }, [
        field
    ]);
}
export { useFormInitiallyScrollToField };
